type UserConstantsType = {
  SPECIAL_RANKS: Record<string, string>;
  PROPERTY: {
    GENDER: Record<string, string>;
  };
  DM_STATUS: Record<string, number>;
  DM_STATUS_ID_OPTIONS: number[];
  RECEIVE_MAIL_MAGAZINE_OPTIONS: number[];
  VALIDATION: {
    PASSWORD_MIN_LENGTH: number;
    PASSWORD_MAX_LENGTH: number;
    PASSWORD_REGEX: RegExp;
    LAST_NAME_MAX_LENGTH: number;
    FIRST_NAME_MAX_LENGTH: number;
    LAST_NAME_KANA_REGEX: RegExp;
    LAST_NAME_KANA_MAX_LENGTH: number;
    FIRST_NAME_KANA_REGEX: RegExp;
    FIRST_NAME_KANA_MAX_LENGTH: number;
    POSTAL_CODE1_LENGTH: number;
    POSTAL_CODE1_REGEX: RegExp;
    POSTAL_CODE2_LENGTH: number;
    POSTAL_CODE2_REGEX: RegExp;
    CITY_MAX_LENGTH: number;
    TOWN_MAX_LENGTH: number;
    TOWN2_MAX_LENGTH: number;
    BUILDING_MAX_LENGTH: number;
    TEL1_REGEX: RegExp;
    TEL1_MAX_LENGTH: number;
    TEL1_MIN_LENGTH: number;
    TEL2_REGEX: RegExp;
    TEL2_MAX_LENGTH: number;
    TEL2_MIN_LENGTH: number;
    TEL3_REGEX: RegExp;
    TEL3_MAX_LENGTH: number;
    EMAIL_DOT_PATTERN_REGEX: RegExp;
    EMAIL_MAX_LENGTH: number;
    CONTENTS_MAX_LENGTH: number;
    AGREE_CHOICES: boolean[];
    SELECTION_CHOICES: number[];
    ANSWER_METHOD_CHOICES: number[];
    PHONE_NUMBER_REGEX: RegExp;
    INVALID_CHARACTER_TARGET_FIELDS: Record<string, string>;
  };
};

export const USER_CONSTANTS: UserConstantsType = {
  SPECIAL_RANKS: {
    '3': 'ゴールド',
    '4': 'プラチナ',
    '5': 'その他',
  },
  PROPERTY: {
    GENDER: {
      '1': '男性',
      '2': '女性',
      '9': 'その他',
    },
  },
  DM_STATUS: {
    OK_ID: 1,
    NG_REASON_OB_ID: 2,
    NG_REASON_USER_ID: 3,
    NG_REASON_ADDRESS_ID: 4,
    NG_REASON_ELSE_ID: 5,
  },
  DM_STATUS_ID_OPTIONS: [1, 2, 3, 4, 5],
  RECEIVE_MAIL_MAGAZINE_OPTIONS: [0, 1],
  VALIDATION: {
    PASSWORD_MIN_LENGTH: 6,
    PASSWORD_MAX_LENGTH: 30,
    PASSWORD_REGEX: /^(?=.*?[a-z])(?=.*?\d)[a-z\d-]+$/i,
    LAST_NAME_MAX_LENGTH: 80,
    FIRST_NAME_MAX_LENGTH: 80,
    LAST_NAME_KANA_REGEX: /^([ァ-ヴ][ァ-ヴー・]*)$/u,
    LAST_NAME_KANA_MAX_LENGTH: 50,
    FIRST_NAME_KANA_REGEX: /^([ァ-ヴ][ァ-ヴー・]*)$/u,
    FIRST_NAME_KANA_MAX_LENGTH: 50,
    POSTAL_CODE1_LENGTH: 3,
    POSTAL_CODE1_REGEX: /^\d+$/,
    POSTAL_CODE2_LENGTH: 4,
    POSTAL_CODE2_REGEX: /^\d+$/,
    CITY_MAX_LENGTH: 100,
    TOWN_MAX_LENGTH: 100,
    TOWN2_MAX_LENGTH: 100,
    BUILDING_MAX_LENGTH: 100,
    TEL1_REGEX: /^\d+$/,
    TEL1_MAX_LENGTH: 5,
    TEL1_MIN_LENGTH: 2,
    TEL2_REGEX: /^\d+$/,
    TEL2_MAX_LENGTH: 4,
    TEL2_MIN_LENGTH: 1,
    TEL3_REGEX: /^\d+$/,
    TEL3_MAX_LENGTH: 4,
    EMAIL_DOT_PATTERN_REGEX: /^(?!.*\.@)(?!.*\.\.)/,
    EMAIL_MAX_LENGTH: 100,
    CONTENTS_MAX_LENGTH: 500,
    AGREE_CHOICES: [true],
    SELECTION_CHOICES: [1, 2, 3, 4, 5],
    ANSWER_METHOD_CHOICES: [1, 2],
    PHONE_NUMBER_REGEX: /^\d{10,11}$/,
    INVALID_CHARACTER_TARGET_FIELDS: {
      lastName: '名字',
      firstName: '名前',
      city: '市区町村',
      town: '町域名',
      town2: '丁目、番地、号',
      building: 'アパートマンション名 部屋番号・会社名',
    },
  },
} as const;

/**
 * SELECTABLE_YEAR_FROM
 * 誕生日で選択可能な年の最小値
 */
export const SELECTABLE_YEAR_FROM: number = 1901;

/**
 * PASSWORD_MIN_LENGTH
 * パスワードの最小文字数
 */
export const PASSWORD_MIN_LENGTH: number = 6;

/**
 * PASSWORD_MAX_LENGTH
 * パスワードの最大文字数
 */
export const PASSWORD_MAX_LENGTH: number = 30;

/**
 * PASSWORD_REGEX
 * パスワードの正規表現
 */
export const PASSWORD_REGEX: RegExp = /^(?=.*?[a-z])(?=.*?\d)[a-z\d-]+$/i;

/**
 * MALE
 * 男性
 */
export const MALE: number = 1;

/**
 * FEMALE
 * 女性
 */
export const FEMALE: number = 2;

/**
 * GENDER
 * 性別
 * 1: 男性
 * 2: 女性
 */
export const GENDER: Record<number, string> = {
  [MALE]: '男性',
  [FEMALE]: '女性',
};

/**
 * RECEIVE_MAIL_MAGAZINE_NO
 * メールマガジン配信しない
 */
export const RECEIVE_MAIL_MAGAZINE_NO: number = 0;

/**
 * RECEIVE_MAIL_MAGAZINE_YES
 * メールマガジン配信する
 */
export const RECEIVE_MAIL_MAGAZINE_YES: number = 1;

/**
 * RECEIVE_MAIL_MAGAZINE
 * メールマガジン配信
 * 0: 配信しない
 * 1: 配信する
 */
export const RECEIVE_MAIL_MAGAZINE: Record<number, string> = {
  [RECEIVE_MAIL_MAGAZINE_NO]: '配信しない',
  [RECEIVE_MAIL_MAGAZINE_YES]: '配信する',
};

/**
 * DIRECT_MAIL_ISSUE
 * DM発行
 */
export const DIRECT_MAIL_ISSUE: number = 1;

/**
 * DIRECT_MAIL_SENDABLE
 * 送付可
 */
export const DIRECT_MAIL_SENDABLE: string = '送付可';

/**
 * DIRECT_MAIL_NOT_SENDABLE
 * 送付不可
 */
export const DIRECT_MAIL_NOT_SENDABLE: string = '送付不可';
